/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

// TODO: abstract this map from Meter and here into consts
const SIZES_MAP = {
  small: [120, 8, 11],
  medium: [210, 10, 13],
  large: [300, 12, 15],
};

const ORIENTATION_VALUES = {
  top: -90,
  bottom: 90,
};

const progressCss = css({
  display: 'inline-block',
  verticalAlign: 'top',
});

const svgCss = css({
  display: 'block',
  overflow: 'visible',
});

const circleCss = css({
  fill: 'none',
  stroke: Colors.adamantium,
});

const valueBarBaseCss = css({
  fill: 'none',
  strokeLinecap: 'round',
  transition:
    'stroke-dashoffset 2s cubic-bezier(0.19, 1, 0.22, 1), stroke 2s ease-out',
});

type ProgressCircleProps = {
  /** (Optional) The title of the graph. */
  title?: string;
  /** Percent of the value (0-100). */
  percent: number;
  /** Size of the graph. */
  size: 'small' | 'medium' | 'large';
  /** Color of the value bar. */
  barColor: string;
  /** How the graph is positioned. */
  orientation: 'top' | 'bottom';
};

const ProgressCircle = (props: ProgressCircleProps) => {
  const [diameter, barWidth, valueBarWidth] = SIZES_MAP[props.size];
  const center = diameter / 2;
  const radius = diameter / 2 - barWidth / 2;
  const circleProps = {
    cx: center,
    cy: center,
    r: radius,
  };
  const svgStyle = {
    transform: `rotate(${ORIENTATION_VALUES[props.orientation]}deg)`,
  };
  const valueBarCss = css(valueBarBaseCss, {
    stroke: props.barColor,
  });
  const circ = Math.PI * radius * 2;
  const valueBarStyle = {
    strokeDashoffset: (1 - props.percent / 100) * circ,
    strokeDasharray: circ,
  };
  return (
    <div css={progressCss} title={props.title || `${props.percent}%`}>
      <svg
        css={svgCss}
        height={diameter}
        style={svgStyle}
        viewBox={`0 0 ${diameter} ${diameter}`}
        width={diameter}
      >
        <circle {...circleProps} css={circleCss} strokeWidth={barWidth} />
        <circle
          {...circleProps}
          css={valueBarCss}
          strokeWidth={valueBarWidth}
          style={valueBarStyle}
        />
      </svg>
    </div>
  );
};

ProgressCircle.defaultProps = {
  size: 'small',
  barColor: Colors.steel,
  orientation: 'top',
};

export default ProgressCircle;
